import React, { Component } from "react";
import ButtonTheme from "css/themes/Buttons.css";
import DropdownTheme from "css/themes/Dropdown.css";
import _ from "lodash";
import { string } from "prop-types";
import { Button } from "react-toolbox/lib/button";
import Dropdown from "react-toolbox/lib/dropdown";
import COLOURS from "util/colours";
import Field from "visual-components/util/inputs/field";
import Label from "visual-components/util/inputs/label";
import { P } from "visual-components/util/texts";
import { DiscordIcon, ThreadsIcon, TikTokIcon, XIcon, YouTubeIcon } from "../icons";
import DiscordJoin from "./DiscordJoin";
import LinkedInFollow from "./LinkedInFollow";
import ThreadsFollow from "./ThreadsFollow";
import TikTokFollow from "./TikTokFollow";
import TwitchFollow from "./TwitchFollow";
import XFollow from "./XFollow";
import AppDownload from "./app-download";
import FbLike from "./fb-like";
import FbShare from "./fb-share";
import InstagramFollow from "./instagram-follow";
import InstagramVisit from "./instagram-visit";
import PinterestFollow from "./pinterest-follow";
import PinterestPin from "./pinterest-pin";
import SnapchatFollow from "./snapchat-follow";
import YoutubeSubscribe from "./youtube-subscribe";
import YoutubeWatch from "./youtube-watch";

const bonusComponentMap = {
  fbLike: {
    component: FbLike,
    faIcon: "fa-facebook-square",
  },
  fbShare: {
    component: FbShare,
    faIcon: "fa-facebook-square",
  },
  instagramFollow: {
    component: InstagramFollow,
    colour: COLOURS.instagram,
    faIcon: "fa-instagram",
  },
  instagramVisit: {
    component: InstagramVisit,
    colour: COLOURS.instagram,
    faIcon: "fa-instagram",
  },
  youtubeWatch: {
    component: YoutubeWatch,
    // faIcon: "fa-youtube-square",
    iconComponent: <YouTubeIcon color="black" />,
  },
  youtubeSubscribe: {
    component: YoutubeSubscribe,
    // faIcon: "fa-youtube-square",
    iconComponent: <YouTubeIcon color="black" />,
  },
  pinterestFollow: {
    component: PinterestFollow,
    faIcon: "fa-pinterest-square",
  },
  pinterestPin: {
    component: PinterestPin,
    faIcon: "fa-pinterest-square",
  },
  snapchatFollow: {
    component: SnapchatFollow,
    faIcon: "fa-snapchat-square",
  },
  appDownload: {
    component: AppDownload,
    faIcon: "fa-download",
  },
  linkShare: {
    faIcon: "fa-bullhorn",
  },
  tiktokFollow: {
    component: TikTokFollow,
    colour: COLOURS.tiktok,
    // faIcon: "fa-tiktok",
    iconComponent: <TikTokIcon color="black" />,
  },
  tiktokShare: {
    component: TikTokFollow, // Using same component for share
    colour: COLOURS.tiktok,
    // faIcon: "fa-tiktok",
    iconComponent: <TikTokIcon color="black" />,
  },
  xFollow: {
    component: XFollow,
    colour: COLOURS.xBlack,
    // faIcon: "fa-x-twitter",
    iconComponent: <XIcon color="black" />,
  },
  xShare: {
    component: XFollow, // Using same component for share
    colour: COLOURS.xBlack,
    // faIcon: "fa-x-twitter",
    iconComponent: <XIcon color="black" />,
  },
  linkedinFollow: {
    component: LinkedInFollow,
    colour: COLOURS.linkedin,
    faIcon: "fa-linkedin",
  },
  linkedinShare: {
    component: LinkedInFollow, // Using same component for share
    colour: COLOURS.linkedin,
    faIcon: "fa-linkedin",
  },
  whatsappShare: {
    component: null, // WhatsApp share handled differently
    colour: COLOURS.whatsapp,
    faIcon: "fa-whatsapp",
  },
  discordJoin: {
    component: DiscordJoin,
    colour: COLOURS.discord,
    // faIcon: "fa-discord",
    iconComponent: <DiscordIcon color="black" />,
  },
  twitchFollow: {
    component: TwitchFollow,
    colour: COLOURS.twitch,
    faIcon: "fa-twitch",
  },
  threadsFollow: {
    component: ThreadsFollow,
    colour: COLOURS.threads,
    // faIcon: "fab fa-threads",
    iconComponent: <ThreadsIcon color="black" />,
  },
};

export default class BonusItem extends Component {
  static contextTypes = {
    impersonating: string.isRequired,
  };

  updatePersist = () => {
    const {
      updateBonusItem,
      bonus: { id, partnership_invite_id, data },
    } = this.props;

    updateBonusItem(id, partnership_invite_id, data);
  };

  updateBonusDataAttr = (attr, value) => {
    const {
      bonus: { id, partnership_invite_id },
    } = this.props;

    const data = {
      id: id,
      data: {
        [attr]: value,
      },
    };

    store.dispatch({
      model: "bonusItems",
      type: "UPDATE_ITEM",
      data: data,
    });
  };

  render() {
    const {
      bonus,
      bonusItems,
      bonus: { id: bonusId, bonus_type: type, partnership_invite_id, data, expanded, errors },
      partnershipInvite: { id: inviteId },
      isHost,
      expandBonusItem,
      unexpandBonusItem,
      deleteBonusItem,
      currentCampaign,
    } = this.props;

    const { impersonating } = this.context;

    const Component = bonusComponentMap[type]?.component;

    const options = ["0", "1", "2", "3"].map((number) => ({
      value: number,
      label: `+ ${number}/each`,
    }));

    const hasError = _.some(errors, (item) => item.errors && item.errors.length);

    //const ineligableBonus = ["fbShare", "fbLike", "instagramFollow"];
    const ineligableBonus = [];
    const eligable = !ineligableBonus.includes(type);
    const ownsUnit = inviteId === partnership_invite_id;
    const faIcon = bonusComponentMap[type]?.faIcon;
    const iconComponent = bonusComponentMap[type]?.iconComponent;

    if (!ownsUnit && data.hidden && !isHost) {
      return <></>;
    }

    return (
      <div
        style={{
          width: "851px",
          minHeight: "40px",
          border: `solid 1px ${COLOURS.silver}`,
          borderRadius: "1px",
          marginBottom: "12px",
          padding: "2px 12px",
          cursor: "pointer",
        }}
      >
        {isHost && (
          <i
            className="fa fa-bars"
            aria-hidden="true"
            style={{
              color: COLOURS.azure,
              fontSize: "16px",
              marginRight: "24px",
            }}
          />
        )}

        <div
          style={{
            width: "16px",
            display: "inline-block",
            marginRight: "16px",
          }}
        >
          {faIcon && (
            <i
              className={`fa ${faIcon}`}
              aria-hidden="true"
              style={{
                color: COLOURS.ink,
                fontSize: "16px",
              }}
            />
          )}
          {iconComponent}
        </div>

        <div
          style={{
            width: "486px",
            display: "inline-block",
            marginRight: "16px",
          }}
        >
          <P multiline style={{ lineHeight: "36px" }}>
            {`${data.message}${data.hidden && !isHost ? " (Hidden by Host)" : ""}`}
          </P>
        </div>

        <div
          style={{
            width: "11px",
            display: "inline-block",
            marginRight: "104px",
          }}
        >
          {ownsUnit &&
            !expanded &&
            (hasError ? (
              <i
                className="fa fa-times"
                aria-hidden="true"
                style={{
                  fontSize: "20px",
                  color: COLOURS.alertRed,
                }}
              />
            ) : (
              <i
                className="fa fa-check"
                aria-hidden="true"
                style={{
                  fontSize: "20px",
                  color: COLOURS.seaGreen,
                }}
              />
            ))}
        </div>

        <div
          style={{
            display: "inline-block",
            width: "138px",
            textAlign: "right",
          }}
        >
          {ownsUnit && (
            <>
              {expanded ? (
                <Button
                  onClick={(e) => {
                    unexpandBonusItem(bonusId);
                    this.updatePersist();
                    toastr.success("Saved!", null, {
                      timeOut: 2000,
                      positionClass: "toast-bottom-center",
                    });
                  }}
                  className={`${ButtonTheme.noMargin}`}
                  theme={ButtonTheme}
                  label={"Save"}
                  primary
                  flat
                />
              ) : (
                <Button
                  onClick={(e) => expandBonusItem(bonusId)}
                  className={`${ButtonTheme.noMargin}`}
                  theme={ButtonTheme}
                  label={"Edit"}
                  primary
                  flat
                />
              )}
              {data.paid && currentCampaign.startDate < new Date() && !impersonating ? (
                <div style={{ width: "82px", display: "inline-block" }}></div>
              ) : (
                <Button
                  onClick={(e) => deleteBonusItem(bonusId)}
                  theme={ButtonTheme}
                  label={"Delete"}
                  primary
                  flat
                />
              )}
            </>
          )}
        </div>

        <div className={expanded ? "" : "hide"}>
          <div
            style={{
              display: "inline-block",
              width: "210px",
              marginRight: "16px",
            }}
          >
            {eligable ? (
              <div>
                <Label label={"Social Growth"} />
                <Dropdown
                  onChange={(e) => this.updateBonusDataAttr("bonusCount", e)}
                  source={options}
                  value={data.bonusCount ? data.bonusCount.toString() : "2"}
                  className={DropdownTheme.buttonDropdown}
                  theme={DropdownTheme}
                />
              </div>
            ) : (
              <div>
                <P multiline>{"You cannot offer extra entries for this action."}</P>
              </div>
            )}
          </div>
          <div
            style={{
              display: "inline-block",
              width: "599px",
            }}
          >
            <Field
              label={"Custom Message"}
              attrName={"message"}
              dataModel={data}
              formModel={{}}
              updateAttr={this.updateBonusDataAttr}
              disabled={
                !impersonating &&
                //["fbShare", "fbLike", "instagramFollow", "instagramVisit"].includes(type)
                [].includes(type)
              }
            />
          </div>
          {Component && (
            <>
              <Component
                bonus={bonus}
                bonusItems={bonusItems}
                updateBonusDataAttr={this.updateBonusDataAttr}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}
